import * as React from "react";
import {Line} from 'react-chartjs-2';

export class LineChart extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        let {data, title} = this.props;
        const config = {
            labels: data.map((obj: any) => {
                return obj.label;
            }),
            datasets: [
                {
                    title: {
                        display: 'none'
                    },
                    label: '',
                    borderColor: 'rgb(41,138,61)',
                    backgroundColor: 'transparent',
                    borderDash: [5, 5],
                    pointBorderColor: 'rgb(41,138,61)',
                    pointBackgroundColor: 'rgba(41,138,61,1)',
                    pointRadius: 3,
                    pointHoverRadius: 5,
                    pointHitRadius: 30,
                    pointBorderWidth: 2,
                    borderWidth: 1,
                    data: data.map((obj: any) => {
                        return obj.value;
                    }),
                    lineThickness: 2,
                }
            ],
            barThickness: 10,
        };

        const options = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        };

        return (
            <>
                <h4 className="text-center py-3 mt-2">{title}</h4>
                <Line
                    data={config} options={options}
                />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/charts/LineChart.tsx